/**
 * Araç Geçiş Kartları (04.11.2026, Burak): aynı adla iki aktif kart olamaz; HGS aktarımı aracın aktif HGS kartıyla eşleşir.
 * Karşılaştırma Türkçe karakter, büyük-küçük harf ve boşluktan bağımsız (sunucudaki GecisKarti.AyniAdliAktifHatasi ile aynı).
 */
export const kartAdiAnahtari = (ad?: string | null) => (ad ?? '')
    .toLocaleUpperCase('tr-TR')
    .replace(/İ/g, 'I').replace(/Ş/g, 'S').replace(/Ğ/g, 'G').replace(/Ü/g, 'U').replace(/Ö/g, 'O').replace(/Ç/g, 'C')
    .replace(/\s+/g, '');

export interface KartOzeti { id: string, ad?: string | null, aktif: boolean }

/** Yeni / güncellenen kart aktifse ve aynı adla başka aktif kart varsa true. */
export const ayniAdliAktifVar = (kartlar: KartOzeti[], kart: KartOzeti) =>
    kart.aktif && kartAdiAnahtari(kart.ad) !== '' &&
    kartlar.some(k => k.id !== kart.id && k.aktif && kartAdiAnahtari(k.ad) === kartAdiAnahtari(kart.ad));
